import { Fragment, useState } from "react";
import { toast } from "sonner";
import { api, errMsg } from "../../lib/api";

const ROWS = [["at", "Date/time (UTC)"], ["merchant_masked", "Merchant"], ["mode", "Mode"], ["amount", "Amount"], ["currency", "Currency"],
  ["connectivity", "Connectivity"], ["authentication", "Authentication"], ["authorisation", "Authorisation"], ["final_status", "Final status"],
  ["auth_code", "Auth code"], ["resp_code", "Response code"], ["message", "Message"], ["reference", "Reference"]];

export function GatewayTestTxn({ diag, onChanged }) {
  const [busy, setBusy] = useState(false);
  const run = async () => {
    if (busy || !window.confirm("Send ONE $1.00 TEST transaction to the card payment gateway now? No registration or payment record is created.")) return;
    setBusy(true);
    try { const { data } = await api.post("/admin/integrations/gateway/test-transaction"); toast[data.outcome === "PASS" ? "success" : "error"](`Test transaction: ${data.outcome}`); onChanged(); }
    catch (e) { toast.error(errMsg(e)); } finally { setBusy(false); }
  };
  const r = diag.last;
  if (!diag.enabled && !r) return null;
  return (
    <div className="space-y-2 border-t pt-4" data-testid="gateway-test-txn">
      <h3 className="font-semibold text-navy">Test transaction</h3>
      {diag.enabled ? <button type="button" className="btn-outline" disabled={busy} onClick={run} data-testid="gateway-test-txn-btn">{busy ? "Running…" : "Run $1.00 test transaction"}</button>
        : <p className="text-xs text-slate-600" data-testid="gateway-test-txn-disabled">Diagnostic disabled on the server.</p>}
      {r && (
        <div className="text-xs" data-testid="gateway-test-txn-report">
          <p className="mb-1 font-bold" data-testid="gateway-test-txn-outcome">Outcome: {r.outcome}</p>
          <dl className="grid grid-cols-[10rem_1fr] gap-x-2">{ROWS.map(([k, l]) => <Fragment key={k}><dt className="text-slate-600">{l}</dt><dd>{String(r[k] ?? "–")}</dd></Fragment>)}</dl>
          {r.checks && <p className="mt-1">Checks: {Object.entries(r.checks).map(([k, v]) => `${k.replace(/_/g, " ")} ${v ? "✓" : "✗"}`).join(" · ")}</p>}
          <p className="mt-1">Test indicators in response: {Object.keys(r.test_indicators || {}).length ? JSON.stringify(r.test_indicators) : "none"}</p>
          <details className="mt-1"><summary>Sanitised gateway response</summary><pre className="whitespace-pre-wrap">{JSON.stringify(r.response, null, 1)}</pre></details>
        </div>)}
    </div>
  );
}
